import { useParams } from 'react-router-dom'
import { useCallback, useEffect, useMemo, useState } from 'react'

import { Helmet } from 'react-helmet'
import MainHeader from '../../../components/MainHeader.js'
import MainFooter from '../../../components/MainFooter.js'
import { motion } from "framer-motion";

import './ProjectsDetails.css'
import './MProjectsDetails.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightFromBracket, faArrowUpRightFromSquare, faBuilding, faChevronLeft, faLink, faPersonCircleCheck, faPhone } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

import { URL_STRAPI, API_TOKEN_STRAPI, boxvar1, boxvar3, MarkdownViewer, oP, lP, urlBeautify, formatDateWithTime, boxvar2, boxvar2dyndelay } from '../../../core.js'
import { faCalendarCheck } from '@fortawesome/free-regular-svg-icons'
import useInitialViewportVisibility from '../../../hooks/useInitialViewportVisibility.js'

import qs from 'qs'

export default function ProjectsDetails() {

    let { projectid } = useParams()

    const [projectData, setProjectData] = useState(null);

    const [loading, setLoading] = useState(true);

    const [lightbox, setLightbox] = useState({ open: false, src: '', alt: '' });
    const openLightbox = (src, alt) => setLightbox({ open: true, src, alt });
    const closeLightbox = () => setLightbox({ open: false, src: '', alt: '' });

    const fetchProjectData = async () => {
        try {
            const query = qs.stringify({
                filters: {
                    projectid: { $eq: projectid },
                    active: { $eq: true },
                },
                sort: 'publishedAt:desc',
                populate: {
                    logo_img: true,
                    kunde_logo: true,
                    related_news_articles: true,
                    content: {
                        populate: '*',
                    },
                },
            }, { encodeValuesOnly: true });

            const res = await axios.get(`${URL_STRAPI}/api/projects?${query}`, {
                headers: {
                    Authorization: `Bearer ${API_TOKEN_STRAPI}`,
                },
            });

            // const res = await axios.get(`${URL_STRAPI}/api/projects`, {
            //     params: {
            //         'filters[projectid][$eq]': projectid,
            //         'filters[active][$eq]': true,
            //         'sort': 'publishedAt:desc',
            //         // 'pagination[limit]': 1,
            //         // 'populate': '*', // falls Relationen oder Bilder enthalten sind
            // 'populate[logo_img]': '*',
            // 'populate[related_news_articles]': '*',
            // 'populate[content]': '*',
            //     },
            //     headers: {
            //         Authorization: `Bearer ${API_TOKEN_STRAPI}`,
            //     },
            // });
            console.log(res.data.data[0]);

            return res.data.data[0];
        } catch (error) {
            if (error.response && error.response.status === 500) {
                console.error('Server Error: Internal Server Error (500)');

            } else {
                console.error('An error occurred:', error.message);
            }
            return "ERROR";
        }
    };

    useEffect(() => {
        setLoading(true);
        fetchProjectData().then((content) => { setProjectData(content); setLoading(false); });


        const handleKey = (e) => { if (e.key === 'Escape') closeLightbox(); };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [])

    const detailAnimationItems = useMemo(() => {
        if (!projectData) return [];

        const items = [{ key: 'header_box' }, { key: 'button_box' }];
        (projectData?.content || []).forEach((section, index) => {
            items.push({ key: `section_${index}` });
        });
        if ((projectData?.related_news_articles?.length || 0) > 0) {
            items.push({ key: 'news_box' });
        }
        items.push({ key: 'metadata_box' });
        return items;
    }, [projectData]);

    const getAnimationItemId = useCallback((item) => item.key, []);
    const {
        setItemRef: setDetailItemRef,
        isInitiallyVisible: isDetailInitiallyVisible
    } = useInitialViewportVisibility(detailAnimationItems, getAnimationItemId, {
        enabled: !loading && projectData != null,
        resetKey: `project-details-${projectid}`
    });

    const getDetailDelay = useCallback((key, baseDelay = 0.3) => {
        if (!isDetailInitiallyVisible(key)) return 0;
        const index = detailAnimationItems.findIndex((item) => item.key === key);
        if (index < 0) return 0;
        return baseDelay * (index + 1);
    }, [detailAnimationItems, isDetailInitiallyVisible]);




    if (loading == true) return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"projects"} disableanimation={false} />

            <section className='sec_next' id='sec_next--projectdetails'>
                <div className='sec_next_cont' id="sec_next--projectdetails--cont" style={{ wordBreak: "break-word" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/projects'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>
                    <br /><br />
                    <p>Die Informationen über das Projekt werden geladen...</p>
                </div>
            </section >

            <MainFooter />
        </div >
    )
    if (projectData == null) return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"projects"} disableanimation={false} />

            <section className='sec_next' id='sec_next--projectdetails'>
                <div className='sec_next_cont' id="sec_next--projectdetails--cont" style={{ wordBreak: "break-word" }}>
                    <br /><br />
                    <div className='backbtn'><a href='/projects'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>
                    <br /><br />
                    <p>Das Projekt konnte nicht gefunden werden.</p>
                </div>
            </section >

            <MainFooter />
        </div >
    )

    console.log("Content-Zone: ", projectData.content);


    return (
        <div className='mainCon' id='mainCon'>

            <MainHeader selectedsite={"projects"} disableanimation={false} />

            <Helmet>
                <meta charSet="utf-8" />
                <title>Projekt: {projectData.name}</title>
                <meta property="og:title" content={`Projekt: ${projectData.name}`} />
                <meta property="og:description" content={`${projectData.shortdescription}`} />
                <meta name="description" content={projectData.shortdescription} />
            </Helmet>
            <section className='sec_next' id='sec_next--projectdetails'>
                <div className='sec_next_cont' id="sec_next--projectdetails--cont" style={{ wordBreak: "break-word" }}>

                    {/* <motion.div variants={boxvar3} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}> */}
                    <br /><br />

                    <div className='backbtn'><a href='/projects'><FontAwesomeIcon icon={faChevronLeft} /> Zur Übersicht</a></div>


                    <h2 className='projectdata_name' onClick={() => oP(projectData.url_landing != null ? projectData.url_landing : '#')}>{projectData.name} <FontAwesomeIcon icon={faArrowUpRightFromSquare} /></h2>

                    <div className='projectdatacontainer'>
                        <div className='projectdatacontainer_first'>


                            <motion.div
                                ref={setDetailItemRef('header_box')}
                                variants={boxvar2dyndelay}
                                className='projectdata_header_box'
                                initial="hidden"
                                exit="hidden"
                                whileInView="visible"
                                custom={getDetailDelay('header_box')}
                                viewport={{ once: false, margin: "-50px" }}
                            >
                                {/* <div className='projectdata_header_box'> */}
                                {projectData.logo_img != undefined && <img className='projectdata_logo' src={`${URL_STRAPI}${projectData.logo_img?.url}`} alt={"Logo des Projekts: " + projectData.logo_img?.alternativeText} />}

                                <h3>{projectData.shortdescription}</h3>
                                <p>{projectData.longdescription}</p>

                                {/* </div> */}
                            </motion.div>

                            <motion.div
                                ref={setDetailItemRef('button_box')}
                                variants={boxvar2dyndelay}
                                className='projectdata_button_box'
                                initial="hidden"
                                exit="hidden"
                                whileInView="visible"
                                custom={getDetailDelay('button_box')}
                                viewport={{ once: false, margin: "-50px" }}
                            >
                                {/* <div className='projectdata_button_box'> */}


                                {projectData.type == "kunde" ? <div className='projectdata_kunde_cont'>
                                    {projectData.kunde_logo != undefined && <img onClick={() => oP(projectData.kunde_url_landing)} className='projectdata_kunde_logo' src={`${URL_STRAPI}${projectData.kunde_logo?.url}`} alt={"Logo des Kunden: " + projectData.kunde_logo?.alternativeText} />}
                                    <h3 onClick={() => oP(projectData.kunde_url_landing)}>{projectData.kunde_name}</h3>
                                    <hr />
                                </div> : <></>}

                                <>
                                    {
                                        projectData.type == "kunde" ?
                                            <p className='projectdata_type' onClick={() => lP('/projects/?type=kunden')}><FontAwesomeIcon className='projectdata_button_fai' icon={faPersonCircleCheck} />Kundenprojekt</p>
                                            :
                                            <p className='projectdata_type' onClick={() => lP('/projects/?type=projects')}><FontAwesomeIcon className='projectdata_button_fai' icon={faBuilding} />Eigenprodukt</p>
                                    }
                                </>

                                <p><FontAwesomeIcon className='projectdata_button_fai' icon={faCalendarCheck} />{projectData.release_date}</p>

                                <a href={projectData.url_landing} target="_blank" rel=""><FontAwesomeIcon className='projectdata_button_fai' icon={faLink} />{(projectData.url_landing == null) ? "keine Webseite" : urlBeautify(projectData.url_landing)}</a>
                                {projectData.url_app_web != null && (
                                    <>
                                        <br /><br />
                                        <a href={projectData.url_app_web} target="_blank" rel=""><FontAwesomeIcon className='projectdata_button_fai' icon={faArrowRightFromBracket} />Zur Web-App</a>
                                    </>

                                )}
                                {projectData.url_app_ios != null && (
                                    <>
                                        <br /><br />
                                        <a href={projectData.url_app_ios} target="_blank" rel=""><FontAwesomeIcon className='projectdata_button_fai' icon={faArrowRightFromBracket} />Zur iOS-App</a>
                                    </>

                                )}

                                {projectData.url_app_android != null && (
                                    <>
                                        <br /><br />
                                        <a href={projectData.url_app_android} target="_blank" rel=""><FontAwesomeIcon className='projectdata_button_fai' icon={faArrowRightFromBracket} />Zur Android-App</a>
                                    </>

                                )}
                                {projectData.url_support != null && (
                                    <>
                                        <br /><br />
                                        <a href={projectData.url_support} target="_blank" rel=""><FontAwesomeIcon className='projectdata_button_fai' icon={faPhone} />Support</a>
                                    </>

                                )}
                                {/* </div> */}
                            </motion.div>

                        </div>

                        <div className='projectdatacontainer_scnd'>

                            {projectData?.content.map(function (section, index) {
                                return <motion.div
                                    ref={setDetailItemRef(`section_${index}`)}
                                    variants={boxvar2dyndelay}
                                    className='projectdata_section_box'
                                    initial="hidden"
                                    exit="hidden"
                                    whileInView="visible"
                                    custom={getDetailDelay(`section_${index}`)}
                                    viewport={{ once: false, margin: "-50px" }}
                                >

                                    {/* <motion.div variants={boxvar2} initial="hidden" exit="hidden" whileInView="visible" viewport={{ once: false, margin: "-50px" }}> */}
                                    {/* <div className='projectdata_section_box'> */}

                                    {(section.style == 'heroimage' && section.images?.length > 0) &&
                                        <div className='projectdata_section_heroimage'>
                                            <img key={1} src={`${URL_STRAPI}${section.images[0].url}`} alt={section.images[0].alternativeText} />
                                        </div>}
                                    <h3>{section.header}</h3>
                                    <div className='projectdata_section_text'>
                                        <MarkdownViewer
                                            content={section.text?.replace(/\n/g, '  \n')} />
                                    </div>
                                    {section.style == 'gallery' &&
                                        <div className='projectdata_section_gallery'>
                                            {section.images?.map(function (image, index) {
                                                return <img key={index} src={`${URL_STRAPI}${image.url}`} alt={image.alternativeText} onClick={() => openLightbox(`${URL_STRAPI}${image.url}`, image.alternativeText)} />
                                            })}
                                        </div>}
                                    {/* </div> */}
                                </motion.div>

                            })}

                            {projectData?.related_news_articles?.length > 0 ?
                                <motion.div
                                    ref={setDetailItemRef('news_box')}
                                    variants={boxvar2dyndelay}
                                    className='projectdata_news_box'
                                    initial="hidden"
                                    exit="hidden"
                                    whileInView="visible"
                                    custom={getDetailDelay('news_box')}
                                    viewport={{ once: false, margin: "-50px" }}
                                >

                                    {/* <div className='projectdata_news_box'> */}
                                    <h3>Verknüpfte Meldungen:</h3>
                                    <ul>
                                        {projectData?.related_news_articles.map((news) =>

                                            <li key={news.id}><a href={"/news/" + news.newsid}><FontAwesomeIcon className='projectdata_button_fai' icon={faLink} />{news.title} ({news.newsdate})</a></li>
                                        )}

                                    </ul>

                                    {/* </div> */}
                                </motion.div>
                                : <></>}

                        </div>

                    </div>

                    {/* rel="noopener noreferrer" */}
                    <motion.div
                        ref={setDetailItemRef('metadata_box')}
                        variants={boxvar2dyndelay}
                        className=''
                        initial="hidden"
                        exit="hidden"
                        whileInView="visible"
                        custom={getDetailDelay('metadata_box')}
                        viewport={{ once: false, margin: "-50px" }}
                    >

                        <p className='projectdata_metadata'>
                            ID: {projectData.projectid} ● Aktualisiert: {formatDateWithTime(new Date(projectData.updatedAt))}
                        </p>

                    </motion.div>

                    <br /><br /><br /><br /><br /><br /><br />
                    <br /><br /><br /><br /><br /><br /><br />

                </div>
            </section >


            {lightbox.open && (
                <div className='lightbox_overlay' onClick={closeLightbox}>
                    <div className='lightbox_container' onClick={(e) => e.stopPropagation()}>
                        <img
                            src={lightbox.src}
                            alt={lightbox.alt}
                            className='lightbox_image'
                        />
                        <button className='lightbox_close' onClick={closeLightbox}>
                            ×
                        </button>
                        {lightbox.alt && (
                            <p className='lightbox_alt'>{lightbox.alt}</p>
                        )}
                    </div>
                </div>
            )}
            <MainFooter />
        </div >
    )
}
